import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function BasicSelect({
  value,
  label,
  handleChange,
  handleBlur,
  items,
  name,
  MenuProps,
  ...props
}) {
  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth {...props}>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          name={name}
          value={value}
          label={label}
          onChange={handleChange}
          onBlur={handleBlur}
          MenuProps={MenuProps}
        >
          {items?.map((item) => (
            <MenuItem
              value={item.value}
              key={item.value}
              disabled={item.disabled || false}
            >
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
